/**
 * VSG purchase widget store.
 * Pieces subscribe and dispatch; no business rules here yet.
 */
(function () {
  var ROOT_SELECTOR = '[data-pdp-vsg-purchase-widget]';
  var STORE_KEY = '_pdpVsgStore';

  function toId(value) {
    if (value == null || value === '') return null;
    var parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function parseGiftProductIds(value) {
    if (!value) return [];
    return value
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean)
      .map(toId)
      .filter(function (id) {
        return id != null;
      });
  }

  function readGiftProductIds(root) {
    var value = root.getAttribute('data-gift-product-ids');
    if (!value) {
      var giftRoot = root.querySelector('[data-pdp-vsg-gift-selector]');
      if (giftRoot) value = giftRoot.getAttribute('data-gift-product-ids');
    }
    return parseGiftProductIds(value);
  }

  function parseInitialState(root) {
    return {
      variantId: toId(root.getAttribute('data-variant-id')),
      sellingPlanId: toId(root.getAttribute('data-selling-plan-id')),
      giftProductIds: readGiftProductIds(root),
      giftProductId: null,
      giftVariantId: null,
      purchaseType: root.getAttribute('data-purchase-type') || 'onetime'
    };
  }

  function cloneState(state) {
    return {
      variantId: state.variantId,
      sellingPlanId: state.sellingPlanId,
      giftProductIds: state.giftProductIds.slice(),
      giftProductId: state.giftProductId,
      giftVariantId: state.giftVariantId,
      purchaseType: state.purchaseType
    };
  }

  function createStore(initialState) {
    var state = cloneState(initialState);
    var listeners = [];

    function getState() {
      return cloneState(state);
    }

    function subscribe(listener) {
      if (typeof listener !== 'function') return function () {};
      listeners.push(listener);
      return function unsubscribe() {
        var index = listeners.indexOf(listener);
        if (index > -1) listeners.splice(index, 1);
      };
    }

    function dispatch(partial) {
      if (!partial || typeof partial !== 'object') return getState();
      state = cloneState(state);
      Object.keys(partial).forEach(function (key) {
        if (key === 'giftProductIds' && Array.isArray(partial.giftProductIds)) {
          state.giftProductIds = partial.giftProductIds.slice();
          return;
        }
        state[key] = partial[key];
      });
      var snapshot = getState();
      listeners.forEach(function (listener) {
        listener(snapshot);
      });
      return snapshot;
    }

    return {
      getState: getState,
      subscribe: subscribe,
      dispatch: dispatch
    };
  }

  function parsePriceCatalog(root) {
    var el = root.querySelector('[data-pdp-vsg-price-catalog]');
    if (!el) return { variants: {}, moneyFormat: '' };
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return { variants: {}, moneyFormat: '' };
    }
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, '');
  }

  function formatMoney(cents, moneyFormat) {
    if (cents == null || Number.isNaN(Number(cents))) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return stripHtml(window.Shopify.formatMoney(cents, moneyFormat));
    }
    var amount = (Number(cents) / 100).toFixed(2);
    var format = moneyFormat || '${{amount}}';
    if (format.indexOf('amount_no_decimals') !== -1) {
      amount = String(Math.round(Number(cents) / 100));
    } else if (format.indexOf('amount_with_comma_separator') !== -1) {
      amount = (Number(cents) / 100).toFixed(2).replace('.', ',');
    }
    return stripHtml(format.replace(/\{\{\s*[^}]+\s*\}\}/, amount));
  }

  function getVariantRecord(catalog, variantId) {
    if (!catalog || !catalog.variants || variantId == null) return null;
    return catalog.variants[String(variantId)] || null;
  }

  function variantSupportsSubscription(variant) {
    if (!variant || !variant.sellingPlanPrices) return false;
    return Object.keys(variant.sellingPlanPrices).length > 0;
  }

  function firstSellingPlanId(variant) {
    if (!variantSupportsSubscription(variant)) return null;
    return toId(Object.keys(variant.sellingPlanPrices)[0]);
  }

  function resolveSellingPlanId(variant, preferredId) {
    if (!variantSupportsSubscription(variant)) return null;
    if (preferredId != null && variant.sellingPlanPrices[String(preferredId)] != null) {
      return preferredId;
    }
    return firstSellingPlanId(variant);
  }

  function variantSupportsOnetime(variant) {
    if (!variant) return true;
    return !variant.requiresSellingPlan;
  }

  function variantSubscriptionPartial(catalog, state, nextVariantId, preferredPurchaseType) {
    var variant = getVariantRecord(catalog, nextVariantId);
    var partial = { variantId: nextVariantId };
    var canSubscribe = variantSupportsSubscription(variant);
    var canOnetime = variantSupportsOnetime(variant);
    var purchaseType = preferredPurchaseType || state.purchaseType || 'onetime';

    if (purchaseType === 'subscription' && !canSubscribe) {
      purchaseType = 'onetime';
    } else if (purchaseType === 'onetime' && !canOnetime) {
      purchaseType = canSubscribe ? 'subscription' : 'onetime';
    }

    partial.purchaseType = purchaseType;
    if (canSubscribe) {
      // New variant: use its first plan. Preferring the previous plan across
      // variants kept shared plan IDs and froze the Save badge %.
      var planId = firstSellingPlanId(variant);
      if (planId != null) partial.sellingPlanId = planId;
    }
    return partial;
  }

  function resolvePriceCents(state, catalog) {
    var variant = getVariantRecord(catalog, state.variantId);
    if (!variant) return null;
    if (state.purchaseType === 'subscription' && state.sellingPlanId != null) {
      var planPrices = variant.sellingPlanPrices || {};
      var planPrice = planPrices[String(state.sellingPlanId)];
      if (planPrice != null) return planPrice;
    }
    if (state.purchaseType !== 'subscription') {
      var discount = Number(variant.discount) || 0;
      if (discount > 0 && discount < 100) {
        return Math.round((Number(variant.price) * (100 - discount)) / 100);
      }
    }
    return variant.price;
  }

  function syncSellingPlanInput(root, state) {
    var input = root.querySelector('[data-pdp-vsg-selling-plan-id]');
    var shouldSend = state.purchaseType === 'subscription' && state.sellingPlanId != null;
    if (shouldSend) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-pdp-vsg-selling-plan-id', '');
        root.appendChild(input);
      }
      input.disabled = false;
      input.value = String(state.sellingPlanId);
      return;
    }
    if (input) {
      input.disabled = true;
      input.value = '';
    }
  }

  function isCartDrawerOpen() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return false;
    return (
      drawer.classList.contains('open') ||
      drawer.classList.contains('active') ||
      drawer.classList.contains('is-open')
    );
  }

  function addCartItem(payload) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    });
  }

  function openCartDrawer() {
    document.dispatchEvent(
      new CustomEvent('cartItemAdded', { bubbles: true, detail: {} })
    );
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    if (isCartDrawerOpen()) return;
    var icon = document.querySelector('[data-cart-icon]');
    if (icon) icon.click();
  }

  function initAddToCart(root, store) {
    var wrap = root.querySelector('[data-pdp-vsg-add-to-cart]');
    if (!wrap || wrap.getAttribute('data-pdp-vsg-ready') === 'true') return;

    var button = wrap.querySelector('[data-pdp-vsg-atc-button]');
    if (!button) return;

    var labelEl = wrap.querySelector('[data-pdp-vsg-atc-label]');
    var priceEl = wrap.querySelector('[data-pdp-vsg-atc-price]');
    var priceWrap = wrap.querySelector('[data-pdp-vsg-atc-price-wrap]');
    var idleEl = wrap.querySelector('[data-pdp-vsg-atc-idle]');
    var busyEl = wrap.querySelector('[data-pdp-vsg-atc-busy]');
    var catalog = parsePriceCatalog(root);
    var summaryCatalog = parseSummaryCatalog(root);
    var noteSub = wrap.querySelector('[data-pdp-vsg-atc-note-subscription]');
    var noteOne = wrap.querySelector('[data-pdp-vsg-atc-note-onetime]');
    var noteFreq = wrap.querySelector('[data-pdp-vsg-atc-note-frequency]');
    var atcLabel = button.getAttribute('data-label-atc') || 'Add to Cart';
    var subscribeLabel = button.getAttribute('data-label-subscribe') || 'Subscribe & Save';
    var soldOutLabel = button.getAttribute('data-label-sold-out') || 'Sold Out';
    var addingLabel = button.getAttribute('data-label-adding') || 'Adding to cart...';
    var adding = false;

    if (busyEl) busyEl.textContent = addingLabel;

    function setBusy(isBusy) {
      adding = isBusy;
      if (idleEl) idleEl.hidden = isBusy;
      if (busyEl) busyEl.hidden = !isBusy;
      button.disabled = isBusy || button.getAttribute('data-pdp-vsg-sold-out') === 'true';
    }

    function applyState(state) {
      var variant = getVariantRecord(catalog, state.variantId);
      var available = !!(variant && variant.available);
      var isSubscription = state.purchaseType === 'subscription';
      var priceCents = resolvePriceCents(state, catalog);
      var formatted = formatMoney(priceCents, catalog.moneyFormat);
      var idleLabel = soldOutLabel;
      if (available) idleLabel = isSubscription ? subscribeLabel : atcLabel;

      button.setAttribute('data-pdp-vsg-sold-out', available ? 'false' : 'true');
      if (!adding) button.disabled = !available;
      wrap.setAttribute(
        'data-pdp-vsg-purchase-type',
        isSubscription ? 'subscription' : 'onetime'
      );

      if (labelEl) labelEl.textContent = idleLabel;
      if (priceEl && formatted) priceEl.textContent = formatted;
      if (priceWrap) priceWrap.hidden = !available || !formatted;
      if (noteSub) noteSub.hidden = !isSubscription;
      if (noteOne) noteOne.hidden = isSubscription;
      if (noteFreq) {
        var planKey =
          state.sellingPlanId != null
            ? String(state.sellingPlanId)
            : String(summaryCatalog.defaultPlanId || '');
        var plan = (summaryCatalog.plans && summaryCatalog.plans[planKey]) || {};
        noteFreq.textContent = frequencyForPlan(plan);
      }
      syncSellingPlanInput(root, state);
    }

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (adding || button.disabled) return;

      var state = store.getState();
      var variant = getVariantRecord(catalog, state.variantId);
      if (!variant || !variant.available || state.variantId == null) return;

      var payload = {
        id: state.variantId,
        quantity: 1
      };
      if (state.purchaseType === 'subscription' && state.sellingPlanId != null) {
        payload.selling_plan = state.sellingPlanId;
      }

      var gifts = window.PdpVsgCartGifts;
      var productId = toId(root.getAttribute('data-product-id'));
      var giftPayload = null;
      if (state.purchaseType === 'subscription' && state.giftVariantId != null) {
        giftPayload = {
          id: state.giftVariantId,
          quantity: 1,
          properties: gifts
            ? gifts.giftProperties(productId, state.variantId)
            : {
                _gift: 'true',
                _gift_parent_product_id: productId != null ? String(productId) : '',
                _gift_parent_variant_id: String(state.variantId)
              }
        };
      }

      function addGiftIfNeeded() {
        if (!giftPayload) return null;
        var cartPromise = gifts && typeof gifts.fetchCart === 'function'
          ? gifts.fetchCart()
          : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
              if (!response.ok) throw new Error('Failed to load cart');
              return response.json();
            });
        return cartPromise
          .then(function (cart) {
            var alreadyInCart =
              gifts && typeof gifts.hasGiftVariant === 'function'
                ? gifts.hasGiftVariant(cart, giftPayload.id, state.variantId)
                : (cart.items || []).some(function (item) {
                    var props = item.properties || {};
                    if (String(props._gift) !== 'true') return false;
                    if (Number(item.variant_id) !== Number(giftPayload.id)) return false;
                    return String(props._gift_parent_variant_id || '') === String(state.variantId);
                  });
            if (alreadyInCart) return null;
            return addCartItem(giftPayload);
          })
          .catch(function () {
            return null;
          });
      }

      setBusy(true);

      addCartItem(payload)
        .then(function () {
          if (gifts && typeof gifts.reconcile === 'function') return gifts.reconcile();
          return addGiftIfNeeded();
        })
        .then(function () {
          openCartDrawer();
        })
        .catch(function () {
          // Keep the idle label; caller can retry.
        })
        .then(function () {
          setBusy(false);
          applyState(store.getState());
        });
    });

    root.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!adding) button.click();
    });

    wrap.setAttribute('data-pdp-vsg-ready', 'true');
    store.subscribe(applyState);
    applyState(store.getState());
  }

  function initVariantSelector(root, store) {
    var groups = root.querySelectorAll('[data-pdp-vsg-variant-selector]');
    var pending = [];
    groups.forEach(function (group) {
      if (group.getAttribute('data-pdp-vsg-ready') === 'true') return;
      pending.push(group);
    });
    if (!pending.length) return;

    var inputs = [];
    pending.forEach(function (group) {
      group.querySelectorAll('[data-pdp-vsg-variant-option]').forEach(function (input) {
        inputs.push(input);
      });
    });
    var hiddenId = root.querySelector('[data-pdp-vsg-variant-id]');
    var catalog = parsePriceCatalog(root);
    var summaryCatalog = parseSummaryCatalog(root);
    var planDiscounts = parsePlanDiscounts(root);
    var shipLines = [];
    pending.forEach(function (group) {
      group.querySelectorAll('[data-pdp-vsg-variant-ships]').forEach(function (el) {
        shipLines.push(el);
      });
    });

    function planIdForVariantInput(input, state, badge) {
      var variantId = toId(input.value);
      var variant = getVariantRecord(catalog, variantId);
      var purchaseScope = input.getAttribute('data-pdp-vs-variant-purchase-type');
      var isSelected = variantId != null && variantId === state.variantId;
      if (purchaseScope) {
        isSelected = isSelected && state.purchaseType === purchaseScope;
      }

      if (isSelected && state.purchaseType === 'subscription') {
        return resolveSellingPlanId(variant, state.sellingPlanId);
      }
      return (
        toId(badge && badge.getAttribute('data-default-plan-id')) || firstSellingPlanId(variant)
      );
    }

    function unitPriceCents(totalCents, units) {
      var amount = Number(totalCents);
      if (Number.isNaN(amount)) return null;
      if (units > 0) return Math.round(amount / units);
      return amount;
    }

    function pricesForVariantInput(input, state) {
      var variantId = toId(input.value);
      var variant = getVariantRecord(catalog, variantId);
      if (!variant) return null;

      var box = input.closest('[data-pdp-vsg-variant-box]');
      var badge = box && box.querySelector('[data-pdp-vsg-variant-discount]');
      var purchaseScope = input.getAttribute('data-pdp-vs-variant-purchase-type');
      var useSubscription = purchaseScope
        ? purchaseScope === 'subscription'
        : state.purchaseType === 'subscription';
      var units = Number(variant.units) || 0;
      var baseCents = Number(variant.price);
      var finalCents = baseCents;
      var compareCents = null;

      if (useSubscription && variantSupportsSubscription(variant)) {
        var planId = planIdForVariantInput(input, state, badge);
        var summaryVariant =
          summaryCatalog.variants && summaryCatalog.variants[String(variantId)];
        var summaryPlan =
          summaryVariant &&
          summaryVariant.plans &&
          planId != null &&
          summaryVariant.plans[String(planId)];
        if (summaryPlan && summaryPlan.today != null) {
          finalCents = Number(summaryPlan.today);
        } else if (planId != null && variant.sellingPlanPrices) {
          var planPrice = variant.sellingPlanPrices[String(planId)];
          if (planPrice != null) finalCents = Number(planPrice);
        }
        var baseEach = unitPriceCents(baseCents, units);
        var finalEach = unitPriceCents(finalCents, units);
        if (baseEach != null && finalEach != null && baseEach > finalEach) {
          compareCents = baseEach;
        }
        return {
          finalCents: finalEach,
          compareCents: compareCents,
          showEach: units > 0
        };
      }

      var onetimeDiscount = Number(variant.discount) || 0;
      var finalEach = unitPriceCents(baseCents, units);
      if (onetimeDiscount > 0 && onetimeDiscount < 100 && finalEach != null) {
        compareCents = finalEach;
        finalEach = Math.round((finalEach * (100 - onetimeDiscount)) / 100);
      }
      return {
        finalCents: finalEach,
        compareCents: compareCents,
        showEach: units > 0
      };
    }

    function discountPercentForVariant(input, state) {
      var box = input.closest('[data-pdp-vsg-variant-box]');
      var badge = box && box.querySelector('[data-pdp-vsg-variant-discount]');
      var standard = box && box.querySelector('[data-pdp-vsg-variant-standard-price]');
      var purchaseScope = input.getAttribute('data-pdp-vs-variant-purchase-type');
      var useSubscription = purchaseScope
        ? purchaseScope === 'subscription'
        : state.purchaseType === 'subscription';
      var onetimeDiscount = Number(badge && badge.getAttribute('data-onetime-discount')) || 0;

      if (!useSubscription) {
        return {
          badge: badge,
          standard: standard,
          percent: onetimeDiscount,
          showStandard: onetimeDiscount <= 0
        };
      }

      var variantId = toId(input.value);
      var variant = getVariantRecord(catalog, variantId);
      var planId = planIdForVariantInput(input, state, badge);
      var plan =
        (planDiscounts.plans && planId != null && planDiscounts.plans[String(planId)]) || {};
      return {
        badge: badge,
        standard: standard,
        percent: Number(plan.firstOrderPercent) || 0,
        showStandard: false
      };
    }

    function applyState(state) {
      inputs.forEach(function (input) {
        var selected = toId(input.value) === state.variantId;
        var purchaseScope = input.getAttribute('data-pdp-vs-variant-purchase-type');
        if (purchaseScope) {
          selected = selected && state.purchaseType === purchaseScope;
        }
        input.checked = selected;
        var box = input.closest('[data-pdp-vsg-variant-box]');
        if (!box) return;
        box.classList.toggle('pdp-vsg-box--selected', selected);
        box.classList.toggle('pdp-vsg-variant-selector__box--selected', selected);

        var discount = discountPercentForVariant(input, state);
        if (discount.badge) {
          if (discount.percent > 0) {
            discount.badge.textContent = discount.percent + '% off';
            discount.badge.hidden = false;
          } else {
            discount.badge.textContent = '';
            discount.badge.hidden = true;
          }
        }
        if (discount.standard) {
          discount.standard.hidden = !discount.showStandard;
        }

        var prices = pricesForVariantInput(input, state);
        var finalEl = box.querySelector('[data-pdp-vsg-variant-price-final]');
        var compareEl = box.querySelector('[data-pdp-vsg-variant-price-compare]');
        if (prices && finalEl && prices.finalCents != null) {
          var finalText = formatMoney(prices.finalCents, catalog.moneyFormat);
          finalEl.textContent = prices.showEach ? finalText + ' each' : finalText;
        }
        if (prices && compareEl) {
          if (prices.compareCents != null && prices.compareCents > prices.finalCents) {
            compareEl.textContent = formatMoney(prices.compareCents, catalog.moneyFormat);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      });

      if (shipLines.length) {
        var showShips = state.purchaseType === 'subscription';
        shipLines.forEach(function (el) {
          var box = el.closest('[data-pdp-vsg-variant-box]');
          var input = box && box.querySelector('[data-pdp-vsg-variant-option]');
          var variantId = input ? toId(input.value) : null;
          var variant = getVariantRecord(catalog, variantId);
          var purchaseScope = input && input.getAttribute('data-pdp-vs-variant-purchase-type');
          var isSelected = variantId != null && variantId === state.variantId;
          if (purchaseScope) {
            isSelected = isSelected && state.purchaseType === purchaseScope;
          }

          if (!variantSupportsSubscription(variant)) {
            el.hidden = true;
            return;
          }

          if (!el.hasAttribute('data-pdp-vsg-ships-static')) {
            el.hidden = !showShips;
          } else {
            el.hidden = false;
          }

          var planId = null;
          if (isSelected && state.purchaseType === 'subscription') {
            planId = resolveSellingPlanId(variant, state.sellingPlanId);
          } else {
            planId = toId(el.getAttribute('data-default-plan-id')) || firstSellingPlanId(variant);
          }

          var plan =
            (summaryCatalog.plans && planId != null && summaryCatalog.plans[String(planId)]) || {};
          var freqEl = el.querySelector('[data-pdp-vsg-variant-ships-frequency]');
          if (freqEl) freqEl.textContent = frequencyForPlan(plan);
        });
      }

      if (hiddenId && state.variantId != null) {
        hiddenId.value = String(state.variantId);
      }
      root.setAttribute(
        'data-variant-id',
        state.variantId != null ? String(state.variantId) : ''
      );
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var variantId = toId(input.value);
        var purchaseScope = input.getAttribute('data-pdp-vs-variant-purchase-type');
        if (purchaseScope === 'onetime') {
          var onetimePartial = {
            variantId: variantId,
            purchaseType: 'onetime'
          };
          var onetimeVariant = getVariantRecord(catalog, variantId);
          var onetimePlanId = firstSellingPlanId(onetimeVariant);
          if (onetimePlanId != null) onetimePartial.sellingPlanId = onetimePlanId;
          store.dispatch(onetimePartial);
          return;
        }
        store.dispatch(
          variantSubscriptionPartial(
            catalog,
            store.getState(),
            variantId,
            purchaseScope === 'subscription' ? 'subscription' : null
          )
        );
      });
    });

    pending.forEach(function (group) {
      group.setAttribute('data-pdp-vsg-ready', 'true');
    });
    store.subscribe(applyState);
    applyState(store.getState());
  }

  function initSubscriptionType(root, store) {
    var group = root.querySelector('[data-pdp-vsg-subscription-type]');
    if (!group || group.getAttribute('data-pdp-vsg-ready') === 'true') return;

    var select = group.querySelector('[data-pdp-vsg-selling-plan-option]');
    if (!select) return;
    var catalog = parsePriceCatalog(root);
    var optionTemplates = Array.prototype.map.call(select.options, function (option) {
      return option.cloneNode(true);
    });

    function renderPlanOptions(variant, sellingPlanId) {
      var prices = (variant && variant.sellingPlanPrices) || {};
      var selectedValue = sellingPlanId != null ? String(sellingPlanId) : '';
      select.replaceChildren();
      optionTemplates.forEach(function (template) {
        if (prices[template.value] == null) return;
        var option = template.cloneNode(true);
        option.hidden = false;
        option.disabled = false;
        option.selected = option.value === selectedValue;
        select.appendChild(option);
      });
      if (selectedValue && prices[selectedValue] != null) {
        select.value = selectedValue;
      }
    }

    function applyState(state) {
      var variant = getVariantRecord(catalog, state.variantId);
      var canSubscribe = variantSupportsSubscription(variant);
      var resolved = canSubscribe ? resolveSellingPlanId(variant, state.sellingPlanId) : null;

      if (canSubscribe && resolved != null && resolved !== state.sellingPlanId) {
        store.dispatch({ sellingPlanId: resolved });
        return;
      }

      renderPlanOptions(variant, resolved);

      var isSubscription = state.purchaseType === 'subscription' && canSubscribe;
      select.disabled = !isSubscription;
      group.classList.toggle('pdp-vsg-subscription-type--disabled', !canSubscribe);
      group.classList.toggle('pdp-vsg-subscription-type--single', select.options.length === 1);

      root.setAttribute(
        'data-selling-plan-id',
        state.sellingPlanId != null ? String(state.sellingPlanId) : ''
      );
    }

    select.addEventListener('change', function () {
      store.dispatch({ sellingPlanId: toId(select.value) });
    });

    group.setAttribute('data-pdp-vsg-ready', 'true');
    store.subscribe(applyState);
    applyState(store.getState());
  }

  function singularFrequencyUnit(unit) {
    var value = String(unit || '').toLowerCase();
    if (value === 'day' || value === 'days' || value === 'daily') return 'day';
    if (value === 'week' || value === 'weeks' || value === 'weekly') return 'week';
    if (value === 'month' || value === 'months' || value === 'monthly') return 'month';
    if (value === 'year' || value === 'years' || value === 'yearly') return 'year';
    return '';
  }

  function formatFrequencyLabel(count, unit) {
    var base = singularFrequencyUnit(unit);
    if (!base) return '';
    var amount = Number(count);
    if (!amount || amount === 1) return 'every ' + base;
    return 'every ' + amount + ' ' + base + 's';
  }

  function parseFrequencyFromText(text) {
    if (!text) return '';
    var source = String(text);
    var numbered = source.match(/(\d+)\s*(day|days|week|weeks|month|months|year|years)\b/i);
    if (numbered) return formatFrequencyLabel(numbered[1], numbered[2]);
    var word = source.match(/\b(daily|weekly|monthly|yearly)\b/i);
    if (word) return formatFrequencyLabel(1, word[1]);
    return '';
  }

  function frequencyForPlan(plan) {
    if (!plan) return 'every order';
    var fromPolicy = formatFrequencyLabel(plan.intervalCount, plan.interval);
    if (fromPolicy) return fromPolicy;
    var fromFrequency = parseFrequencyFromText(plan.frequency);
    if (fromFrequency) return fromFrequency;
    var options = plan.options || [];
    for (var i = 0; i < options.length; i++) {
      var fromOption = parseFrequencyFromText(options[i]);
      if (fromOption) return fromOption;
    }
    return parseFrequencyFromText(plan.name) || 'every order';
  }

  function parseSummaryCatalog(root) {
    var el = root.querySelector('[data-pdp-vsg-summary-catalog]');
    if (!el) return { defaultPlanId: null, moneyFormat: '', plans: {}, variants: {} };
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return { defaultPlanId: null, moneyFormat: '', plans: {}, variants: {} };
    }
  }

  function applySubscriptionSummary(root, state, catalog) {
    var box = root.querySelector('[data-pdp-vsg-subscription-summary]');
    if (!box || !catalog) return;

    var priceVariant = getVariantRecord(parsePriceCatalog(root), state.variantId);
    if (!variantSupportsSubscription(priceVariant)) return;

    var planKey =
      state.sellingPlanId != null ? String(state.sellingPlanId) : String(catalog.defaultPlanId || '');
    var variant = (catalog.variants && catalog.variants[String(state.variantId)]) || {};
    var prices = (variant.plans && variant.plans[planKey]) || {};
    var frequency = frequencyForPlan((catalog.plans && catalog.plans[planKey]) || {});

    var todayEl = box.querySelector('[data-pdp-vsg-summary-today]');
    var recurringEl = box.querySelector('[data-pdp-vsg-summary-recurring]');
    var frequencyEl = box.querySelector('[data-pdp-vsg-summary-frequency]');

    if (todayEl && prices.today != null) {
      todayEl.textContent = formatMoney(prices.today, catalog.moneyFormat);
    }
    if (recurringEl && prices.recurring != null) {
      recurringEl.textContent = formatMoney(prices.recurring, catalog.moneyFormat);
    }
    if (frequencyEl) frequencyEl.textContent = frequency;
  }

  function initSubscriptionSummary(root, store) {
    var box = root.querySelector('[data-pdp-vsg-subscription-summary]');
    if (!box || box.getAttribute('data-pdp-vsg-ready') === 'true') return;

    var catalog = parseSummaryCatalog(root);

    function applyState(state) {
      applySubscriptionSummary(root, state, catalog);
    }

    box.setAttribute('data-pdp-vsg-ready', 'true');
    store.subscribe(applyState);
    applyState(store.getState());
  }

  function parsePlanDiscounts(root) {
    var el = root.querySelector('[data-pdp-vsg-plan-discounts]');
    if (!el) return { defaultPlanId: null, plans: {} };
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return { defaultPlanId: null, plans: {} };
    }
  }

  function applyPlanDiscountCopy(group, state, catalog, priceCatalog) {
    var meta = group.querySelector('[data-pdp-vsg-subscription-meta]');
    if (!meta) return;

    var plans = (catalog && catalog.plans) || {};
    var variant = getVariantRecord(priceCatalog, state.variantId);
    var planId = resolveSellingPlanId(variant, state.sellingPlanId);
    var planKey =
      planId != null ? String(planId) : String(catalog.defaultPlanId || '');
    var plan = plans[planKey] || plans[String(catalog.defaultPlanId || '')] || {};
    var leadText = plan.lead || '';
    var restText = plan.rest || '';

    var leadEl = meta.querySelector('[data-pdp-vsg-discount-lead]');
    var restEl = meta.querySelector('[data-pdp-vsg-discount-rest]');
    var itemEl = meta.querySelector('[data-pdp-vsg-discount-item]');
    if (leadEl) leadEl.textContent = leadText;
    if (restEl) restEl.textContent = restText;
    if (itemEl) itemEl.hidden = !leadText && !restText;
    meta.hidden = !meta.querySelector('li:not([hidden])');
  }

  function applySubscribeBadge(group, state, discounts, priceCatalog) {
    var badge = group.querySelector('[data-pdp-vsg-purchase-badge]');
    if (!badge) return;

    var variant = getVariantRecord(priceCatalog, state.variantId);
    if (!variantSupportsSubscription(variant)) {
      badge.textContent = '';
      badge.hidden = true;
      return;
    }

    var planId = resolveSellingPlanId(variant, state.sellingPlanId);
    var plan =
      (discounts && discounts.plans && planId != null && discounts.plans[String(planId)]) || {};
    var percent = Number(plan.firstOrderPercent);
    if (percent > 0) {
      badge.textContent = 'Save ' + percent + '%';
      badge.hidden = false;
      return;
    }
    badge.textContent = '';
    badge.hidden = true;
  }

  function applyPurchaseTypePrices(group, state, priceCatalog, summaryCatalog) {
    var variant = getVariantRecord(priceCatalog, state.variantId);
    if (!variant) return;

    var originalCents = variant.price;
    var subscribeCents = originalCents;
    var planKey =
      state.sellingPlanId != null ? String(state.sellingPlanId) : '';
    var summaryVariant =
      summaryCatalog && summaryCatalog.variants && summaryCatalog.variants[String(state.variantId)];
    var summaryPlan = summaryVariant && summaryVariant.plans && summaryVariant.plans[planKey];
    if (summaryPlan && summaryPlan.today != null) {
      subscribeCents = summaryPlan.today;
    } else {
      var planPrice = (variant.sellingPlanPrices || {})[planKey];
      if (planPrice != null) subscribeCents = planPrice;
    }

    var originalText = formatMoney(originalCents, priceCatalog.moneyFormat);
    var subscribeText = formatMoney(subscribeCents, priceCatalog.moneyFormat);
    var discountPercent = Number(variant.discount) || 0;
    var onetimeFinalCents = originalCents;
    if (discountPercent > 0 && discountPercent < 100) {
      onetimeFinalCents = Math.round((Number(originalCents) * (100 - discountPercent)) / 100);
    }
    var onetimeFinalText = formatMoney(onetimeFinalCents, priceCatalog.moneyFormat);

    var subPrices = group.querySelector('[data-pdp-vsg-purchase-prices="subscription"]');
    if (subPrices && variantSupportsSubscription(variant)) {
      var compareEl = subPrices.querySelector('[data-pdp-vsg-purchase-compare]');
      var subFinal = subPrices.querySelector('[data-pdp-vsg-purchase-final]');
      if (subFinal) subFinal.textContent = subscribeText;
      if (compareEl) {
        compareEl.textContent = originalText;
        compareEl.hidden = !(Number(subscribeCents) < Number(originalCents));
      }
    }

    var onePrices = group.querySelector('[data-pdp-vsg-purchase-prices="onetime"]');
    if (onePrices) {
      var oneFinal = onePrices.querySelector('[data-pdp-vsg-purchase-final]');
      var oneCompare = onePrices.querySelector('[data-pdp-vsg-purchase-compare]');
      if (oneFinal) oneFinal.textContent = onetimeFinalText;
      if (oneCompare) {
        oneCompare.textContent = originalText;
        oneCompare.hidden = !(Number(onetimeFinalCents) < Number(originalCents));
      }
      if (group.hasAttribute('data-pdp-vs-purchase-type')) {
        onePrices.hidden = state.purchaseType !== 'onetime';
      }
    }
  }

  function initPurchaseType(root, store) {
    var group = root.querySelector('[data-pdp-vsg-purchase-type]');
    if (!group || group.getAttribute('data-pdp-vsg-ready') === 'true') return;

    var isVs = group.hasAttribute('data-pdp-vs-purchase-type');
    var inputs = group.querySelectorAll('[data-pdp-vsg-purchase-type-option]');
    var discounts = parsePlanDiscounts(root);
    var priceCatalog = parsePriceCatalog(root);
    var summaryCatalog = parseSummaryCatalog(root);

    function firstSubscriptionVariantId() {
      var firstSub = root.querySelector(
        '[data-pdp-vs-variant-purchase-type="subscription"]:not(:disabled)'
      );
      return firstSub ? toId(firstSub.value) : null;
    }

    function applyState(state) {
      var variant = getVariantRecord(priceCatalog, state.variantId);
      var canSubscribe = variantSupportsSubscription(variant);

      if (state.purchaseType === 'subscription' && !canSubscribe) {
        if (isVs) {
          var nextVariantId = firstSubscriptionVariantId();
          if (nextVariantId != null) {
            store.dispatch(
              variantSubscriptionPartial(priceCatalog, state, nextVariantId, 'subscription')
            );
            return;
          }
        }
        store.dispatch({ purchaseType: 'onetime' });
        return;
      }

      var purchaseType =
        state.purchaseType === 'subscription' && canSubscribe ? 'subscription' : 'onetime';

      inputs.forEach(function (input) {
        var isSubscriptionOption = input.value === 'subscription';
        var selected = input.value === purchaseType;
        input.disabled = !isVs && isSubscriptionOption && !canSubscribe;
        input.checked = selected;
        var box = input.closest('[data-pdp-vsg-purchase-type-box]');
        if (!box) return;
        box.classList.toggle('pdp-vsg-box--selected', selected);
        box.classList.toggle('pdp-vsg-purchase-type__box--selected', selected);
        box.classList.toggle('pdp-vsg-box--disabled', !isVs && isSubscriptionOption && !canSubscribe);
        box.classList.toggle(
          'pdp-vsg-purchase-type__box--disabled',
          !isVs && isSubscriptionOption && !canSubscribe
        );
      });

      applyPlanDiscountCopy(group, state, discounts, priceCatalog);
      applySubscribeBadge(group, state, discounts, priceCatalog);
      applyPurchaseTypePrices(group, state, priceCatalog, summaryCatalog);
      root.setAttribute('data-purchase-type', purchaseType);
    }

    function selectPurchaseType(nextType) {
      var partial = { purchaseType: nextType };
      if (isVs && nextType === 'onetime') {
        var popular = root.querySelector(
          '[data-pdp-vs-variant-purchase-type="onetime"][data-pdp-vs-most-popular]:not(:disabled)'
        );
        if (popular) partial.variantId = toId(popular.value);
      }
      if (isVs && nextType === 'subscription') {
        var current = getVariantRecord(priceCatalog, store.getState().variantId);
        if (!variantSupportsSubscription(current)) {
          var nextVariantId = firstSubscriptionVariantId();
          if (nextVariantId != null) {
            store.dispatch(
              variantSubscriptionPartial(
                priceCatalog,
                store.getState(),
                nextVariantId,
                'subscription'
              )
            );
            return;
          }
        }
      }
      store.dispatch(partial);
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked || input.disabled) return;
        selectPurchaseType(input.value === 'subscription' ? 'subscription' : 'onetime');
      });

      if (!isVs) return;
      var box = input.closest('[data-pdp-vsg-purchase-type-box]');
      if (!box) return;
      box.addEventListener('click', function (event) {
        if (input.disabled || input.checked) return;
        var target = event.target;
        if (
          target.closest('[data-pdp-vsg-variant-box]') ||
          target.closest('[data-pdp-vsg-subscription-type]') ||
          target.closest('select') ||
          target.closest('a') ||
          target.closest('button')
        ) {
          return;
        }
        if (input.id && target.closest('label[for="' + input.id + '"]')) return;
        input.checked = true;
        selectPurchaseType(input.value === 'subscription' ? 'subscription' : 'onetime');
      });
    });

    group.setAttribute('data-pdp-vsg-ready', 'true');
    store.subscribe(applyState);
    applyState(store.getState());
  }

  function findGiftBoxForVariant(boxes, variantId) {
    if (variantId == null) return null;
    for (var i = 0; i < boxes.length; i++) {
      if (toId(boxes[i].getAttribute('data-gift-parent-variant-id')) === variantId) {
        return boxes[i];
      }
    }
    return null;
  }

  function initGiftSelector(root, store) {
    var group = root.querySelector('[data-pdp-vsg-gift-selector]');
    if (!group || group.getAttribute('data-pdp-vsg-ready') === 'true') return;

    var boxes = group.querySelectorAll('[data-pdp-vsg-gift-box]');

    function resolveGift(state) {
      var enabled = state.purchaseType === 'subscription';
      var box = findGiftBoxForVariant(boxes, state.variantId);
      var available = box && box.getAttribute('data-gift-available') !== 'false';
      return {
        enabled: enabled,
        box: box,
        productId: enabled && box ? toId(box.getAttribute('data-gift-product-id')) : null,
        variantId:
          enabled && box && available ? toId(box.getAttribute('data-gift-variant-id')) : null
      };
    }

    function applyState(state) {
      var gift = resolveGift(state);
      group.classList.toggle('pdp-vsg-gift-selector--disabled', !gift.enabled);
      if (gift.enabled) group.removeAttribute('aria-disabled');
      else group.setAttribute('aria-disabled', 'true');

      boxes.forEach(function (box) {
        var selected = gift.enabled && box === gift.box;
        box.classList.toggle('pdp-vsg-box--selected', selected);
        box.classList.toggle('pdp-vsg-gift-selector__box--selected', selected);
      });

      if (state.giftProductId !== gift.productId || state.giftVariantId !== gift.variantId) {
        store.dispatch({
          giftProductId: gift.productId,
          giftVariantId: gift.variantId
        });
      }
    }

    group.setAttribute('data-pdp-vsg-ready', 'true');
    store.subscribe(applyState);
    applyState(store.getState());
  }

  function initRoot(root) {
    if (!root) return null;
    if (root[STORE_KEY]) return root[STORE_KEY];
    var store = createStore(parseInitialState(root));
    root[STORE_KEY] = store;

    var catalog = parsePriceCatalog(root);
    var initial = store.getState();
    var variant = getVariantRecord(catalog, initial.variantId);
    var patch = {};
    if (!variantSupportsSubscription(variant)) {
      if (initial.purchaseType !== 'onetime') patch.purchaseType = 'onetime';
    } else {
      var planId = resolveSellingPlanId(variant, initial.sellingPlanId);
      if (planId != null && planId !== initial.sellingPlanId) {
        patch.sellingPlanId = planId;
      }
    }
    if (Object.keys(patch).length) store.dispatch(patch);

    initVariantSelector(root, store);
    initSubscriptionType(root, store);
    initGiftSelector(root, store);
    initPurchaseType(root, store);
    initSubscriptionSummary(root, store);
    initAddToCart(root, store);
    return store;
  }

  function boot(scope) {
    var rootScope = scope && scope.querySelectorAll ? scope : document;
    rootScope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  function getStore(el) {
    var root = el && el.closest ? el.closest(ROOT_SELECTOR) : null;
    if (!root) return null;
    return root[STORE_KEY] || initRoot(root);
  }

  window.PdpVsgPurchaseWidget = {
    getStore: getStore,
    init: initRoot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
